import(/* webpackMode: "eager" */ "/home/buyme/htdocs/buyme.lk/node_modules/next/dist/client/link.js");
